
import React from 'react';
import { Outlet } from 'react-router-dom';
import { CartProvider } from './CartProvider';
import './globals.css';

export default function Layout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="min-h-screen flex flex-col font-['Geist',sans-serif]">
      <CartProvider>
        {children || <Outlet />}
      </CartProvider>
    </div>
  );
}
